import { useState } from 'react';
import { FaUserTie, FaBuilding } from 'react-icons/fa';
import { useLanguage } from '../../../context/LanguageContext';

export default function LoginStep1UserType({ onSelectUserType }) {
  const [selected, setSelected] = useState('');
  const { translate } = useLanguage();

  const handleSelect = (type) => {
    setSelected(type);
    setTimeout(() => onSelectUserType(type), 200);
  };

  const options = [
    {
      id: 'buyer',
      title: translate("auth.login.buyerTitle"),
      description: translate("auth.login.buyerDesc"),
      icon: <FaUserTie className="text-blue-400 text-3xl" />,
    },
    {
      id: 'seller',
      title: translate("auth.login.sellerTitle"),
      description: translate("auth.login.sellerDesc"),
      icon: <FaBuilding className="text-blue-400 text-3xl" />,
    },
  ];

  return (
    <div className="flex flex-col items-center justify-between h-full space-y-8 px-2">
      {/* Header */}
      <div className="text-center w-full">
        <h2 className="text-2xl font-bold text-white mb-3">
          {translate("auth.login.whoAreYou")}
        </h2>
        <p className="text-gray-300 text-sm">
          {translate("auth.login.selectAccountType")}
        </p>
      </div>

      {/* Options – centered vertically */}
      <div className="flex flex-col gap-5 w-full max-w-sm mx-auto flex-grow justify-center">
        {options.map((option) => (
          <label
            key={option.id}
            className={`
              flex items-center p-5 border rounded-xl cursor-pointer transition-all duration-300
              ${selected === option.id
                ? 'border-blue-500 bg-blue-900/30 shadow-sm shadow-blue-500/20'
                : 'border-gray-700 hover:border-blue-600 hover:bg-blue-950/30'}
            `}
          >
            <input
              type="radio"
              name="userType"
              value={option.id}
              className="hidden"
              checked={selected === option.id}
              onChange={() => handleSelect(option.id)}
            />

            <div className="flex-shrink-0 w-16 h-16 flex items-center justify-center rounded-xl mr-5 bg-gray-800/50">
              {option.icon}
            </div>

            <div className="flex-1">
              <h3 className="font-semibold text-white text-lg">{option.title}</h3>
              <p className="text-sm text-gray-400 mt-1.5">{option.description}</p>
            </div>

            <div
              className={`w-6 h-6 border-2 rounded-full flex items-center justify-center ml-4 transition-all
                ${selected === option.id ? 'border-blue-500 bg-blue-500' : 'border-gray-600'}
              `}
            >
              {selected === option.id && (
                <svg className="w-4 h-4 text-white" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clipRule="evenodd" />
                </svg>
              )}
            </div>
          </label>
        ))}
      </div>

      {/* Spacer to match Step 2 height */}
      <div className="h-20 invisible" aria-hidden="true" />
    </div>
  );
}